import React from 'react';
import SwiperCore, { Pagination } from 'swiper';
import PDPContentWellProps from '../../models/pdp-well';
import PDPImageWell from './pdp-image-well/PdpImageWell';
import PDPBikeInfo from './pdp-bike-info/PdpBikeInfo';
import PDPContentWell from './pdp-content-well/PdpContentWell';
import styles from './pdp-well.module.scss';

SwiperCore.use([Pagination]);

type Props = {
  data: PDPContentWellProps;
};

export default ({
  data: { pdpContentWell, pdpImageWell, pdpProductDescription }
}: Props) => {
  return (
    <section className={styles['pdp-well']}>
      <div className={styles['pdp-well__container']}>
        <PDPImageWell data={pdpImageWell} />
        {pdpProductDescription && (
          <PDPBikeInfo
            title={pdpProductDescription.productTitle}
            rating={pdpProductDescription.rating}
            numberOfStars={pdpProductDescription.numberOfStars}
            reviews={pdpProductDescription.reviews}
            starIcon={pdpProductDescription.starIcon}
          />
        )}
        <PDPContentWell data={pdpContentWell} />
      </div>
    </section>
  );
};
